import { requestApi } from '../../../services/api.js';

export const FETCH_RESOURCES_SUCCESS = '@komigen/mobile-frontend/resources/FETCH_RESOURCES_SUCCESS';

export const selectResources = state => state.resources.resourcesByKey;

export const resourceLookup = keys => async dispatch => {
	if (!keys || !keys.length) return;
	try {
		const resourceUrlParams = keys.map(key => `key=${key}`).join('&');
		const { result } = await requestApi(`/rest/resources?${resourceUrlParams}`);
		dispatch({
			type: FETCH_RESOURCES_SUCCESS,
			payload: { resourcesByKey: { ...result } }
		});
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error(error);
	}
};

export const refresh = () => (dispatch, getState) => {
	const allResources = selectResources(getState());
	const keys = Object.keys(allResources || {});
	dispatch(resourceLookup(keys));
};

const initialState = {
	resourcesByKey: {}
};

const reducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case FETCH_RESOURCES_SUCCESS:
			return {
				...state,
				resourcesByKey: {
					...state.resourcesByKey,
					...payload.resourcesByKey
				}
			};
		default:
			return state;
	}
};

export default reducer;
